import * as React from 'react';

export interface GameStatsProps {
    score: number;
    discards: number;
    cards: number;
    highScore: number;
}

export function GameStats({score, discards, cards, highScore}: GameStatsProps) {
  return (
    <div className='stats'>
        <div className='score'>Score: {score}</div>
        {/* <div className='score'>Discards: {discards}</div> */}
        <div>Cards remaining: {cards}</div>
        <div>High score: {highScore}</div>
    </div>
  );
}
